import React from 'react'

import { withTranslate } from 'react-redux-multilingual'
import { Card, Grid, CardContent, CardMedia, Typography } from '@material-ui/core'
import Image from '../../../../Image/Image'
import moment from 'moment'

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const AssignmentInfo = ({ assignmentInfo, translate }) => {
  const theme = useTheme()
  const MobileVertical = useMediaQuery(theme.breakpoints.down('xs'))

  if (!assignmentInfo) {
    return null
  }

  let imagePath = null
  let empOrOrgName = null
  let empOrOrgCode = null
  let orgName = null
  let levelName = null
  let positionName = null
  let formName = assignmentInfo?.form?.form_name
  let appraisalYear = assignmentInfo?.form?.appraisal_year
  let startDateDisplay = moment(assignmentInfo?.form?.start_date, 'YYYY-MM-DD').format(
    'DD MMM YYYY'
  )

  let endDateDisplay = moment(assignmentInfo?.form?.end_date, 'YYYY-MM-DD').format('DD MMM YYYY')

  let resultScore = assignmentInfo.result_score
  let resultDisplay = null

  if (
    assignmentInfo.appraisal_type?.appraisal_type_code === 'APT01' ||
    assignmentInfo.appraisal_type?.value_list_code === 'APT01'
  ) {
    empOrOrgName = assignmentInfo?.org?.org_name
    empOrOrgCode = assignmentInfo?.org?.org?.org_code
    levelName = assignmentInfo?.level?.level_name
    imagePath = '/test'
  } else {
    empOrOrgName = assignmentInfo?.emp?.full_name
    empOrOrgCode = assignmentInfo?.emp?.emp_code
    orgName = assignmentInfo?.org?.org_name
    positionName = assignmentInfo?.position?.position_name
    imagePath = assignmentInfo?.emp?.image_path
    levelName = assignmentInfo?.level?.level_name
  }

  if (resultScore) {
    const margin = `0 ${parseInt(theme.spacing(1) / 4)}px`
    const maxPercentScore = 100
    const maxActualScore = 5
    const percentScore = parseFloat(resultScore)
    const actualScore = parseFloat((resultScore / maxPercentScore) * maxActualScore)
    resultDisplay = (
      <React.Fragment>
        <Typography variant={'h5'} component={Grid} item>{`${translate('totalScore')}`}</Typography>
        <Grid
          container
          item
          alignItems={'baseline'}
          justify={MobileVertical ? 'flex-start' : 'flex-end'}
          style={{ whiteSpace: 'nowrap' }}>
          <Typography
            component={Grid}
            item
            variant={MobileVertical ? 'h5' : 'h4'}
            style={{ margin }}>
            {percentScore.toFixed(2)}
          </Typography>
          <Typography component={Grid} item variant={'body1'} style={{ margin }}>
            ({actualScore.toFixed(2)})
          </Typography>
          <Typography
            component={Grid}
            item
            variant={MobileVertical ? 'h5' : 'h4'}
            style={{ margin }}>
            / {maxPercentScore.toFixed(2)}
          </Typography>
          <Typography component={Grid} item variant={'body1'} style={{ margin }}>
            ({maxActualScore.toFixed(2)})
          </Typography>
        </Grid>
      </React.Fragment>
    )
  }

  const imageDisplay = (
    <Grid container item xs={2} justify={'center'}>
      <CardMedia>
        <Image
          src={imagePath}
          imgAlt={empOrOrgName}
          style={{ width: 100, height: 100, maxWidth: '100%', maxHeight: '100%' }}
        />
      </CardMedia>
    </Grid>
  )

  const detailDisplay = (
    <Grid item xs={MobileVertical ? 12 : true}>
      <CardContent style={{ paddingTop: 0, paddingBottom: 0, textAlign: 'left' }}>
        <Typography variant={'h6'}>{empOrOrgName}</Typography>
        <Typography variant={'subtitle1'}>{empOrOrgCode}</Typography>
        <Typography variant={'body2'}>{orgName}</Typography>
        <Typography variant={'body2'}>{levelName}</Typography>
        <Typography variant={'body2'}>{positionName}</Typography>
        <Typography variant={'body2'}>
          {formName} | {appraisalYear} | {startDateDisplay} - {endDateDisplay}
        </Typography>
      </CardContent>
    </Grid>
  )

  const scoreDisplay = (
    <Grid item xs={MobileVertical ? 12 : 4}>
      <CardContent
        style={{
          height: MobileVertical ? 'inherit' : 100,
          padding: MobileVertical ? theme.spacing(2) : `0 ${theme.spacing(2)}px`
        }}>
        <Grid
          container
          direction={'column'}
          style={{ textAlign: MobileVertical ? 'left' : 'right' }}>
          <Grid item>{resultDisplay}</Grid>
        </Grid>
      </CardContent>
    </Grid>
  )

  return (
    <CardContent>
      <Card>
        <CardContent style={{ padding: theme.spacing(1) }}>
          <Grid container justify={'space-evenly'} alignItems={'center'}>
            {imageDisplay}
            {detailDisplay}
            {scoreDisplay}
          </Grid>
        </CardContent>
      </Card>
    </CardContent>
  )
}

export default withTranslate(AssignmentInfo)
